import React, { useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";
import { setActiveLayout } from "../../store/templates/templatesSlice";

const Header = ({ filter, setFilter }) => {
  const { collections: templateCategories, activeLayout } = useSelector(
    (state) => state.templates
  );

  const isVerticalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.VERTICAL,
    [activeLayout]
  );
  const isHorizontalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.HORIZONTAL,
    [activeLayout]
  );
  const dispatch = useDispatch();

  const scrollContainer = useRef(null);

  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  const selectCategoriesFun = (name) => {
    return setFilter(name);
  };
  const onClick = (layout = TEMPLATE_LAYOUT.HORIZONTAL) => {
    return dispatch(setActiveLayout(layout));
  };

  return (
    <div className="flex flex-col px-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-sm">All Themes</h1>

        <div className="flex space-x-4">
          <div className="flex space-x-2">
            <button
              onClick={() => onClick(TEMPLATE_LAYOUT.HORIZONTAL)}
              className={`px-4 py-1 text-sm  rounded-full ${
                isHorizontalLayout ? "bg-gray-300" : "border border-gray-300"
              }`}
            >
              Landscape
            </button>
            <button
              onClick={() => onClick(TEMPLATE_LAYOUT.VERTICAL)}
              className={`px-4 py-1 text-sm  rounded-full ${
                isVerticalLayout ? "bg-gray-300" : "border border-gray-300"
              }`}
            >
              Portrait
            </button>
          </div>

          <div className="relative">
            {/* <input
              type="text"
              placeholder="Search template by name"
              className="px-3 py-2 rounded-full text-sm border border-gray-300"
            /> */}
          </div>
        </div>
      </div>

      <div className="flex items-center">
        <span className="text-gray-400 cursor-pointer" onClick={scrollLeft}>
          &lt;
        </span>

        <div
          ref={scrollContainer}
          className="flex overflow-x-auto scroll-container space-x-4 items-center"
        >
          {[
            { label: "All", value: "" },
            ...templateCategories.map((category) => ({
              value: category.name,
              label: category.name,
            })),
          ].map((item, index) => (
            <button
              key={item?.value}
              className={`px-2 py-1 text-xs text-vb-label-gray2 rounded-full ${
                filter === item.value ? "bg-gray-200" : ""
              }`}
              onClick={() => selectCategoriesFun(item.value)}
            >
              {item?.label}
            </button>
          ))}
        </div>

        <span className="text-gray-400 cursor-pointer" onClick={scrollRight}>
          &gt;
        </span>
      </div>
    </div>
  );
};

export default Header;
